import { render, staticRenderFns } from "./manage-permissions-folder.vue?vue&type=template&id=8a29a076&scoped=true&"
import script from "./manage-permissions-folder.vue?vue&type=script&lang=js&"
export * from "./manage-permissions-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a29a076",
  null
  
)

export default component.exports